var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6494 33.9793C64.7635 32.8498 65.2199 31.837 66.0566 30.9412C66.7792 30.1622 67.616 29.6948 68.5288 29.5H74.5V39.6272H69.5937C68.2245 39.6272 67.0835 39.1208 66.0946 38.1081C65.2199 37.2122 64.8015 36.1995 64.6874 35.07V33.9793H64.6494ZM33.538 29.539H39.4712C40.384 29.7337 41.2208 30.2011 41.9434 30.9801C42.8182 31.876 43.2365 32.8887 43.3506 34.0183V35.07C43.2365 36.1995 42.7801 37.2122 41.9434 38.1081C40.9545 39.1208 39.8135 39.6272 38.4443 39.6272H33.538V29.539ZM68.6809 72.3068C64.8015 76.3967 59.8952 78.5 54 78.5C48.1429 78.5 43.1985 76.4356 39.3191 72.3068C35.4777 68.217 33.5 63.0755 33.5 56.9992V44.3402H43.3126C43.3126 44.3402 43.3126 58.4793 43.3506 58.8299C43.5788 61.3617 44.6058 63.504 46.5074 65.3736C48.6753 67.5548 51.1095 68.6065 53.962 68.6065C56.8145 68.6065 59.2486 67.5548 61.4165 65.3736C62.7477 64.0493 63.6605 62.5302 64.1549 60.8943C64.4592 59.9205 64.6113 58.8299 64.6113 57.7393V44.3402H74.4239V56.9992C74.5 63.0755 72.5223 68.217 68.6809 72.3068Z",
    fill: "#3B0C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingLogo);
export default __webpack_public_path__ + "static/media/LoadingLogo.c161d990.svg";
export { ForwardRef as ReactComponent };